import { render, staticRenderFns } from "./NavbarDropdown.vue?vue&type=template&id=1d23680f"
import script from "./NavbarDropdown.vue?vue&type=script&lang=js"
export * from "./NavbarDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports